<template>
  <div class="radio-picture-select-attribute-editor">
    <label
      class="generic_editor_radio__label"
      :class="{
        'input__label--required': isRequired
      }"
    >
      {{ label }}
    </label>
    <div class="generic_editor_radio">
      <label
        v-for="possibleValue in possibleValues"
        :key="possibleValue.id"
        class="generic_editor_radio__option"
        v-tooltip="possibleValue.pictureUrl ? possibleValue.description : ''"
        :for="`radio-${name}-${possibleValue.id}`"
      >
        <Field
          as=""
          :name="name"
          :value="possibleValue.id"
          :label="possibleValue.description"
          :rules="rules ?? ''"
          v-slot="fieldSlotProps"
        >
          <input
            :name="name"
            :value="possibleValue.id"
            :id="`radio-${name}-${possibleValue.id}`"
            type="radio"
            class="radio-input__input"
            :checked="initialValue === possibleValue.id"
            @change="(event) => {
              fieldSlotProps.handleChange(event)
              changeHandler()
            }"
            @blur="fieldSlotProps.handleBlur"
          >
        </Field>

        <img
          v-if="possibleValue.pictureUrl"
          class="generic_editor_radio__image"
          :src="possibleValue.pictureUrl"
          :alt="possibleValue.description"
        >
        <p class="generic_editor_radio__text">
          {{ possibleValue.id }}
        </p>
      </label>
    </div>
  </div>
</template>

<script>
  import RadioInputVee4 from "../radioInput/radioInputVee4.vue";
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
      RadioInputVee4,
    },
    props: {
      name: String,
      label: String,
      rules: [Object, String],
      possibleValues: Array,
      initialValue: String,
    },
    emits: ['change'],
    methods: {
      isRequired() {
        if (typeof this.rules === 'object') {
          return this.rules.required
        }
        return this.rules?.includes('required')
      },
      changeHandler() {
        this.$emit('change')
      },
    }
  };

</script>
